export default function (degrees: number) {
  return degrees * Math.PI / 180;
}



// WEBPACK FOOTER //
// ./client/functions/degreesToRadians.tsx